/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type FilterInOp = typeof FilterInOp[keyof typeof FilterInOp];


export const FilterInOp = {
  eq: 'eq',
  neq: 'neq',
  in: 'in',
  contains: 'contains',
  gte: 'gte',
  lte: 'lte',
  between: 'between',
  is_null: 'is_null',
  is_not_null: 'is_not_null',
} as const;
